<template>
  <div class="discount-card flex w-full">
    <!-- Icon -->
    <div
      class="discount-card__icon w-24 flex flex-shrink-0 bg-primary-light rounded-l"
      v-dompurify-html:svg="iconSource"
    />

    <!-- Text -->
    <div class="p-4 md:py-6 text-left tracking-0.5px bg-white-high-emphasis rounded-r border-gray-divider border border-l-0 flex-grow">
      <div v-dompurify-html="discount.htmlContent" class="richtext"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Discount } from '../../../model/DiscountsSection'
import useRemoteIcon from '@/hooks/useRemoteIcon'

export default defineComponent({
  props: {
    discount: {
      required: true,
      type: Object as () => Discount,
      validator: (value: Discount) => !!value.htmlContent && !!value.iconUrl
    }
  },
  setup (props) {
    const iconSource = useRemoteIcon(props.discount.iconUrl)

    return { iconSource }
  }
})
</script>

<style>
.discount-card {
  min-height: 100px;

  &__icon svg {
    @apply w-10 h-10 m-auto fill-current text-primary;
   
  }
}

@screen md {
  .discount-card {
    min-height: 120px;
  }
}
</style>
